import IPages from 'src/dataModel/IPages';

const pages: IPages[] = [
  // {
  //   id: '230',
  //   pid: '220',
  //   name: '网元管理',
  //   url: '/datadict/netelementmanager/',
  //   icon: '',
  // },
];
export default pages;


// WEBPACK FOOTER //
// ./src/config/Menus.ts